import React, { useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { useFlags } from 'launchdarkly-react-client-sdk';

import { Integration } from '@futrli-sdk/app-store';

import { OrganisationUploadDrawer } from './organisation-upload-drawer';
import { CreateFromExcelModalContent } from './create-from-excel-modal-content';
import { OrganisationListItem, WorkspacesListingItem } from '@futrli-sdk/workspaces';

interface Props {
  workspaceId: string;
  isOpen: boolean;
  onClose: () => void;
  integration?: Integration;
  isOnboarding?: boolean;
  businessId?: string | null;
  workspaceByBusinessId?: WorkspacesListingItem;
  organisationByBusinessId?: OrganisationListItem;
}

const DEFAULT_SELECTED_COUNTRY_CODE = 'GB';

export const CreateOrganisationUploadDrawer = ({
  isOpen,
  onClose,
  workspaceId,
  integration,
  isOnboarding,
  businessId,
  workspaceByBusinessId,
  organisationByBusinessId
}: Props) => {
  const flags = useFlags();
  const intl = useIntl();

  const [countryCode, setCountryCode] = useState(intl.locale === 'fr-FR' ? 'FR' : DEFAULT_SELECTED_COUNTRY_CODE);

  if (!integration) {
    return null;
  }

  return (
    <OrganisationUploadDrawer
      title={
        <FormattedMessage
          id="predict.create_organisation_from_excel"
          defaultMessage="Create an organisation from an Excel upload"
        />
      }
      isOpen={isOpen}
      handleClose={onClose}
      workspaceId={workspaceId}
      excelIntegration={integration}
      disableCreate={!countryCode}
      countryCode={flags.excelOrgCountryCode ? countryCode : undefined}
      isOnboarding={isOnboarding}
      workspaceByBusinessId={workspaceByBusinessId}
      organisationByBusinessId={organisationByBusinessId}
      businessId={businessId}
    >
      <CreateFromExcelModalContent
        countryCode={flags.excelOrgCountryCode ? countryCode : undefined}
        onChangeCountryCode={flags.excelOrgCountryCode ? setCountryCode : undefined}
      />
    </OrganisationUploadDrawer>
  );
};
